module.exports = __webpack_public_path__ + "img/offer-badge-icon.7837d882.svg";